import { primaryButton } from "./globalStyles"

// "/erro"
export const erroStyles = {
    container: {
      h: '100%',
      pt: 10,
      pb: 10,
    },
    card: {
      direction: 'column',
      align: 'center',
      justify: 'center',
      p: 10,
      bg: 'white',
      rounded: '2xl',
      boxShadow: 'lg',
      textAlign: 'center',
      maxWidth: 'md',
    },
    icon: {
      size: 48,
      color: '#E53E3E',
    },
    heading: {
      mt: 4,
      color: 'gray.700',
    },
    text: {
      mt: 2,
      fontSize: 'md',
      color: 'gray.600',
    },
    button: {
      mt: 6,
      ...primaryButton,
    },
  }